export class DistributeClassContent {
  public classes: string[] = [];
}

export class DistributeGroupContent {
  public groups: string[] = [];
}